export default [
  {
    path: '/app/vigilancia/control-ingreso-salida',
    name: 'rt-viligancia-is',
    component: () => import('@/views/erp/vigilancia/control-ingreso-salida/ControlList.vue'),
  },
]
